"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _settings = require("../settings.js");
var _color = _interopRequireDefault(require("color"));
var _classnames = _interopRequireDefault(require("classnames"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _style = _interopRequireDefault(require("./style.css"));
var _react = require("@emotion/react");
var _templateObject;
/** @jsx jsx */
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var HeaderPreview = function HeaderPreview(props) {
  var _props$settings = props.settings,
    nextButtonTitle = _props$settings.nextButtonTitle,
    prevButtonTitle = _props$settings.prevButtonTitle,
    showProgressBar = _props$settings.showProgressBar,
    showPrevButton = _props$settings.showPrevButton,
    navigationColor = _props$settings.navigationColor,
    useSegmentedProgressBar = _props$settings.useSegmentedProgressBar;
  var pageTitleColorHex = (0, _settings.getTitleColor)(navigationColor);
  var pageTitleColorHexDarken = (0, _color["default"])(pageTitleColorHex).darken(0.1).hex();
  var isLightColor = (0, _color["default"])(pageTitleColorHex).luminosity() > 0.5;
  return (0, _react.jsx)("div", {
    className: _style["default"].navigation,
    css: (0, _react.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                button.btn {\n                    background-color: ", ";\n                    border-color: ", ";\n                    color: ", ";\n\n                    &:hover {\n                        background-color: ", ";\n                        border-color: ", ";\n                    }\n                }\n                .progress-bar {\n                    background-color: ", ";\n                }\n                .", ":before {\n                    background-color: ", ";\n                }\n            "])), pageTitleColorHex, pageTitleColorHexDarken, isLightColor ? '#333' : '#fff', pageTitleColorHexDarken, pageTitleColorHexDarken, pageTitleColorHex, _style["default"].segmentedProgressBar, pageTitleColorHex)
  }, showPrevButton && (0, _react.jsx)("div", null, (0, _react.jsx)("button", {
    type: "button",
    className: "btn btn-primary"
  }, (0, _react.jsx)(_cccisdWysiwyg.Html, {
    content: prevButtonTitle
  }))), showProgressBar ? (0, _react.jsx)("div", {
    className: (0, _classnames["default"])(_style["default"].progressBar, useSegmentedProgressBar && _style["default"].segmentedProgressBar)
  }, (0, _react.jsx)("div", {
    className: "progress"
  }, (0, _react.jsx)("div", {
    className: "progress-bar",
    style: {
      width: '60%'
    }
  }))) : (0, _react.jsx)("div", {
    className: _style["default"].progressBar
  }), (0, _react.jsx)("div", null, (0, _react.jsx)("button", {
    type: "button",
    className: "btn btn-primary"
  }, (0, _react.jsx)(_cccisdWysiwyg.Html, {
    content: nextButtonTitle
  }))));
};
HeaderPreview.propTypes = {
  settings: _propTypes["default"].object
};
HeaderPreview.defaultProps = {};
var _default = exports["default"] = HeaderPreview;